/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  parentForm: Object,
  model: Object,
  resetModels: Array,
  resetFields: Array,
  fields: ?Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewSiteSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, parentForm, model, fields }: TypeProps = this.props;

    // Site
    if (fields.site) {
      const field: Object = parentForm.$(`${fields.site}`);
      const fieldExtra: Object = field.extra;

      field.set('value', actionDrawerStore.response.name);
      field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
      // IDs should be returned in success save of locations
      model.filterId = parentForm.$(`${fields.company}`).extra.selectID;
      model.parentId = parentForm.$(`${fields.company}`).extra.selectID;
      model.selected = actionDrawerStore.response.id;
      model.search = '';
      model.loadData();
    }

    // Country
    if (fields.country) {
      parentForm.$(`${fields.country}`).set('value', actionDrawerStore.response.country_id);
    }

    this.props.onMountHook();

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
